import React from "react";
import Modal from "components/modal";
import { 
  MdPerson, 
  MdSchool, 
  MdEvent,
  MdDateRange,
  MdBookmark,
  MdCategory,
  MdEdit, 
  MdDelete
} from "react-icons/md";

const InscriptionDetailModal = ({ 
  isOpen, 
  onClose, 
  inscription,
  onEdit,
  onDelete
}) => {
  // Formatage de la date
  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(date);
    } catch (error) {
      return dateString;
    }
  };

  if (!inscription) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} width="md">
      <div>
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-1">
            Inscription de {inscription.nom_prenom_membre}
          </h2>
          <div className="flex items-center text-sm text-gray-600">
            <MdEvent className="mr-1 h-4 w-4" />
            <span>Inscrit(e) le {formatDate(inscription.date_inscrit)}</span>
          </div>
          <div className="h-1 w-16 bg-purple-600 mt-4 rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div className="space-y-4">
            <div className="flex items-start">
              <MdPerson className="h-5 w-5 text-purple-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-gray-700">Étudiant</h3>
                <p className="text-base text-gray-900">{inscription.nom_prenom_membre}</p>
              </div>
            </div>

            <div className="flex items-start">
              <MdDateRange className="h-5 w-5 text-purple-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-gray-700">Année universitaire</h3>
                <p className="text-base text-gray-900">{inscription.dateuniv}</p>
              </div>
            </div>

            <div className="flex items-start">
              <MdEvent className="h-5 w-5 text-purple-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-gray-700">Date d'inscription</h3>
                <p className="text-base text-gray-900">{formatDate(inscription.date_inscrit)}</p>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <div className="flex items-start">
              <MdSchool className="h-5 w-5 text-purple-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-gray-700">Niveau</h3>
                <p className="text-base text-gray-900">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800 border border-purple-200">
                    {inscription.niveau}
                  </span>
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <MdBookmark className="h-5 w-5 text-purple-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-gray-700">Parcours</h3>
                <p className="text-base text-gray-900">{inscription.name_parcours}</p>
              </div>
            </div>

            <div className="flex items-start">
              <MdCategory className="h-5 w-5 text-purple-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-gray-700">Mention</h3>
                <p className="text-base text-gray-900">{inscription.name_mention}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 flex justify-end gap-3">
          <button
            type="button"
            onClick={onEdit}
            className="inline-flex items-center px-4 py-2 rounded-md text-purple-700 bg-purple-100 hover:bg-purple-200 border border-transparent"
          >
            <MdEdit className="mr-2 h-4 w-4" />
            Modifier
          </button>
          <button
            type="button"
            onClick={onDelete}
            className="inline-flex items-center px-4 py-2 rounded-md text-red-700 bg-red-100 hover:bg-red-200 border border-transparent"
          >
            <MdDelete className="mr-2 h-4 w-4" />
            Supprimer
          </button>
          <button
            type="button"
            className="px-4 py-2 rounded-md text-gray-600 border border-gray-300 bg-white hover:bg-gray-50 transition-colors"
            onClick={onClose}
          >
            Fermer
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default InscriptionDetailModal;